<template>
    <div>
        <Editor
            :style="`height:${o_editorHeight}px;`"
            api-key="k289zzqjm4i6a9mbuhd7vs91e7ti3g8qfiii8ctzrwkmk2v3"
            :init="textEditorConfig"
            v-model="note.text"
            @onBlur="onBlurHadler()"
            @onKeyDown="onKeyDownHandler()"
            @onPaste="onPasteHandler()"
            @onChange="onKeyDownHandler()"
        />
    </div>
</template>
<script>
import Editor from '@tinymce/tinymce-vue';
import {debounce} from 'lodash'
export default {
    name: 'NotesEditor',
    props: {
        editorHeight: {
            type: Number,
            default: 300
        },
        noteObj: {
            type: Object
        }
    },
    data() {
        return {
            isEditorReady: false,
            o_editorHeight: this.editorHeight,
            note: this.noteObj,
            // Конфиг редактора s
            textEditorConfig: {
                toolbar: 'styleselect | numlist bullist | textcolor colorpicker | forecolor backcolor ',
                plugins: 'autoresize print searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists textcolor imagetools contextmenu colorpicker textpattern',
                autoresize_min_height: 300,
                max_height: 2000,
                menubar: false,
                inline: false,
                content_css: [
                    '/static/disc/tinymce.css',
                    '//fonts.googleapis.com/css?family=Lato:300,300i,400,400i',
                ],
                language_url: '/static/tinymce_langs/ru.js',
                language: 'ru',
                setup : function(ed) {
                    ed.on('init', function () {
                        ed.focus();
                    })
                    ed.on('keydown', function(event) {
                        if (event.keyCode == 9) { // tab pressed
                            if (event.shiftKey) {
                                ed.execCommand('Outdent');
                            }
                            else {
                                ed.execCommand('Indent');
                            }
                            event.preventDefault();
                            return false;
                        }
                    });
                }
            }
        }
    },
    components: {
        Editor
    },
    methods: {
        onBlurHadler: debounce(function(){
            // Удаляем если там пусто когда клиент вышел
            let _isEmptyNote = this.note.text.length === 0 ? true : false
            if(_isEmptyNote && this.note.id) {
                this.deleteNote(this.note.id)
            }
        },1000),

        onPasteHandler: debounce(function() { 
            if(this.note.text.length===0) {
                this.$dmsErrorNoty('Ошибка при создании заметки, попробуйте еще раз')
                return
            }
            let _isNewNote = this.note.text.length === 0 ? true : false
            let _content = this.note.text
            if(this.note.id) {
                this.updateNote({
                    id: this.note.id,
                    date: this.note.date,
                    text: this.note.text
                })
            } else {
                this.createNewNote({
                    date: this.note.date,
                    text: this.note.text
                })
            }
        },1000),

        onKeyDownHandler: debounce(function(){
            //Проверяем пустая или нет, проверяем есть ли id
            if(this.note.text.replace(/<\/?[^>]+(>|$)/g, "").length === 0) return
            if(this.note.id) {
                this.updateNote({
                    id: this.note.id,
                    date: this.note.date,
                    text: this.note.text
                })
            } else if(!this.note.id && this.note.text.length !== 0) {
                this.createNewNote({
                    date: this.note.date,
                    text: this.note.text
                })
            }
        },1000),

        createNewNote(newNote) {
            store.dispatch('WRITE_NOTE', newNote).then((res) => {
                let _out = store.getters['GET_RANGE_NOTES']
                let _targetId = _out.find(note=>note.date === newNote.date)
                this.$dmsSuccessNoty('Заметка создана успешно');
                this.$bus.$emit('createNote', _targetId)
            }).catch(e => {
                // this.$dmsErrorNoty("Ошибка при создании заметки");
                console.error(e);
            });    
        },
        deleteNote(id) {
            if(!id && !this.note.id) return
            store.dispatch('DELETE_NOTE', id).then(() => {
                this.$dmsSuccessNoty(`Заметка с id:${id} удалена`);
                this.$bus.$emit('deleteNote', {})
                this.note.id = null
            }).catch(e => {
                // this.$dmsErrorNoty('Ошибка при удалении заметки');
                throw new Error(e);
            });
        },
        updateNote(note) {
            store.dispatch('UPDATE_NOTE', note).then(() => {
                this.$dmsSuccessNoty('Заметка обновлена');
            }).catch(e => {
                this.$dmsErrorNoty('Ошибка при обновлении заметки');
                console.error(e);
            });
        }
    },
    mounted() {
        setTimeout(()=>{
            this.isEditorReady=true
        },1000)
        
    }    
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/apps/bpm/notes/components/notes/NotesEditor.vue